import { TRADE_PANORAMA_ART } from "../config/tradeQuarter";
import { tradePanoramaCrop, type TradePanoramaKind } from "../phaser/tradePanoramaLayout";
export type { TradePanoramaKind } from "../phaser/tradePanoramaLayout";

export function tradePanoramaViewBox(kind: TradePanoramaKind): string {
  const p = tradePanoramaCrop(kind);
  return `${p.x} ${p.y} ${p.width} ${p.height}`;
}

/** Native loading fallback for the same raster camera used by Phaser. No vector artwork. */
export function renderTradePanorama(kind: TradePanoramaKind, className: string): string {
  return `<svg class="${className}" data-trade-panorama viewBox="${tradePanoramaViewBox(kind)}" preserveAspectRatio="xMidYMid slice" aria-hidden="true"><image href="${TRADE_PANORAMA_ART.map}" width="${TRADE_PANORAMA_ART.width}" height="${TRADE_PANORAMA_ART.height}"/></svg>`;
}
